<template>
  <aside class="FooterRelatedItems">
    <BackLink v-bind="viewMoreLink" />
    <h3 class="heading">{{ heading }}</h3>
    <div class="articles">
      <ArticlePreview v-for="resource in resourceLinks"
        :key="resource._id"
        :content="resource"
      />
    </div>
  </aside>
</template>

<script>
import ArticlePreview from '../shared/ArticlePreview.vue'
import BackLink from './BackLink.vue'

export default {
  components: {
    ArticlePreview,
    BackLink,
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    resourceLinks: {
      type: Array,
      default: () => [],
    },
    viewMoreLink: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>

.heading {
  margin-top: var(--spacing-5);
  font-weight: 600;
  font-size: var(--font-size-5);
  color: var(--text-color-black);
}

.articles {
  margin-top: var(--spacing-5);
  display: grid;
  gap: var(--spacing-7) var(--spacing-5);
}

@media (--screen-md) {
  .articles {
    grid-template-columns: repeat(2, 1fr)
  }
}

@media (--screen-lg) {
  .articles {
    grid-template-columns: repeat(4, 1fr)
  }
}
</style>
